// extracted by mini-css-extract-plugin
module.exports = {"pageMain":"BasicPageLayout_pageMain__1ViXj","container":"BasicPageLayout_container__Idr4v"};